import * as React from 'react';

export default class Home extends React.Component {
  render() {
    return <div className="gx-main-content-wrapper">Walkin Home</div>;
  }
}
